import { useEffect, useState } from 'react';
import { isDesktop } from 'react-device-detect';

const getWindowSize = (): number[] => {
  if (typeof window !== 'undefined') {
    const widthSize =
      isDesktop && window.innerWidth > 580 ? 580 : window.innerWidth;
    return [widthSize, window.innerHeight, window.innerWidth];
  }
  return [0, 0, 0];
};
const useWindowSize = (): number[] => {
  const [size, setSize] = useState(getWindowSize);
  useEffect(() => {
    const widthSize =
      isDesktop && window.innerWidth > 580 ? 580 : window.innerWidth;
    const updateSize = (): void => {
      // export desktop original width as third item in case we need to calculate width for absolute elements
      setSize([widthSize, window.innerHeight, window.innerWidth]);
    };
    // No need to call updateSize immediately if already initialized
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
};
export default useWindowSize;
